
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  position: fixed;
  width: 100%;
  z-index: 9999;
  top: 0;
  left: 0;
  height: 56px;
  background-color: var(--slh-color-neutral, #39455D);
}
:host .skeleton-wrapper {
  position: relative;
  overflow: hidden;
  cursor: not-allowed;
  height: 52px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 24px 8px 8px;
  box-sizing: border-box;
}
:host .skeleton-wrapper .skeleton-actions {
  display: flex;
  align-items: center;
}
:host .skeleton-wrapper .skeleton-actions div:first-child {
  margin-right: 8px;
}
:host .skeleton-wrapper .skeleton-circle {
  box-sizing: border-box;
  outline: none;
  overflow: hidden;
  position: relative;
  background: var(--slh-color-neutral-shade-60, #62779F) no-repeat;
  display: inline-block;
  margin-bottom: 0;
  will-change: transform;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  animation: pulse 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  animation-delay: 0.5s;
}
:host .skeleton-wrapper .skeleton-circle:after, :host .skeleton-wrapper .skeleton-circle:before {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  :host .skeleton-wrapper .skeleton-circle {
    animation: none;
  }
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
:host .slh-nav-headerbar {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
  height: 56px;
  width: 100%;
  background-color: var(--slh-color-neutral, #39455D);
  display: flex;
  padding: 8px 24px 8px 8px;
  box-sizing: border-box;
  align-items: center;
  caret-color: transparent;
}
:host .slh-nav-headerbar.auth {
  justify-content: space-between;
}
:host .slh-nav-headerbar.no-auth {
  justify-content: right;
}
:host .slh-nav-headerbar hr.nav-list-user-separator {
  border: 0;
  height: 1px;
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
  margin: 8px 0 8px 0;
}
:host .slh-nav-headerbar .nav-list-profile {
  display: flex;
  margin-bottom: 12px;
  padding: 8px 4px;
  min-width: 227px;
}
:host .slh-nav-headerbar .nav-list-profile slh-nav-avatar {
  flex-grow: 0;
  flex-shrink: 1;
  height: 48px;
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
}
:host .slh-nav-headerbar .nav-list-profile .user-profile-data {
  flex-grow: 1;
  color: var(--slh-color-neutral-shade-60, #62779F);
  line-height: var(--slh-base-xxs-line-height, 24px);
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
}
:host .slh-nav-headerbar .nav-list-profile .user-profile-data .user-profile-name {
  color: var(--slh-color-neutral, #39455D);
  font-size: var(--slh-base-xs-font-size, 14px);
  font-weight: var(--slh-base-bold-font-weight, 700);
}
:host .slh-nav-headerbar .user-item-label {
  padding-right: 8px;
}
:host .slh-nav-headerbar .guest-user-items .user-item-label {
  min-width: 171px;
}
:host .slh-nav-headerbar .nav-list-user-separator {
  margin-left: -4px !important;
  margin-right: -4px !important;
}
:host .slh-nav-headerbar .settings-items {
  margin-right: 8px;
}
:host .slh-nav-headerbar .cart-items {
  margin-right: 8px;
}
:host .slh-nav-headerbar .cart-items .cart-popup {
  display: flex;
  flex-direction: column;
  max-width: 360px;
  padding: 0;
  font-family: var(--slh-default-font-family, "Open Sans");
  line-height: var(--slh-base-xxs-line-height, 24px);
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 8px 16px;
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-header .cart-popup-title {
  color: var(--slh-color-neutral, #39455D);
  font-size: var(--slh-base-xs-font-size, 14px);
  font-weight: var(--slh-base-bold-font-weight, 700);
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-items {
  max-height: 240px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--slh-color-neutral-shade-40, #C0C8D8) var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-items::-webkit-scrollbar {
  width: 4px;
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-items::-webkit-scrollbar-track {
  background: var(--slh-color-neutral-shade-40, #C0C8D8) var(--slh-color-neutral-shade-00, #FFFFFF);
  width: 4px;
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-items::-webkit-scrollbar-thumb {
  background-color: var(--slh-color-neutral-shade-40, #C0C8D8);
  border-radius: 50px;
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  padding: 4px 16px;
  white-space: nowrap;
  font-style: normal;
  color: var(--slh-color-neutral-shade-60, #62779F);
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-item .cart-popup-item-title {
  flex: 1;
  min-width: 0;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-item .cart-popup-item-price {
  white-space: nowrap;
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 16px;
  color: var(--slh-color-neutral, #39455D);
  font-size: var(--slh-base-xs-font-size, 14px);
  font-weight: var(--slh-base-bold-font-weight, 700);
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-total-amount {
  color: var(--slh-color-neutral, #39455D);
  margin-left: 24px;
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-summary {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-summary .cart-popup-total-amount {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-link {
  margin-left: -4px;
  margin-right: -4px;
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-link slh-icon {
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
:host .slh-nav-headerbar .cart-items .cart-popup .cart-popup-link:hover slh-icon {
  fill: var(--slh-color-neutral, #39455D);
}
:host .slh-nav-headerbar .settings-item {
  min-width: 142px;
  padding: 0 8px;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
}
:host .slh-nav-headerbar slh-icon {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .slh-nav-headerbar .flex-holder {
  display: flex;
  align-items: center;
}
:host .slh-nav-headerbar .activator-holder {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 40px;
  width: 40px;
  flex-shrink: 0;
  position: relative;
}
:host .slh-nav-headerbar .activator-holder.language-switch {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-m-font-size, 16px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
  font-weight: var(--slh-base-bold-font-weight, 700);
  text-transform: uppercase;
}
:host .slh-nav-headerbar .activator-holder.language-switch:hover {
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host .slh-nav-headerbar .activator-holder:focus-visible {
  outline: none;
}
:host .slh-nav-headerbar .activator-holder:focus-visible:after {
  content: "";
  display: block;
  width: calc(100% + 0px);
  height: calc(100% + 0px);
  position: absolute;
  top: "0px";
  left: "0px";
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 32px;
}
:host .slh-nav-headerbar .activator-holder:hover {
  background-color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
:host .slh-nav-headerbar .activator-holder:hover slh-icon {
  fill: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host .slh-nav-headerbar .app-title-holder {
  padding-left: 8px;
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-m-font-size, 16px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-20, #EBEEF4);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
}
:host .slh-nav-headerbar .slh-nav-link {
  display: block;
  text-decoration: none;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-size: var(--slh-base-m-font-size, 16px);
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
  padding: 8px 16px;
  border-radius: 32px;
  position: relative;
}
:host .slh-nav-headerbar .slh-nav-link:focus-visible, :host .slh-nav-headerbar .slh-nav-link:focus {
  outline: none;
}
:host .slh-nav-headerbar .slh-nav-link:focus-visible::after {
  content: "";
  display: block;
  width: calc(100% + 0px);
  height: calc(100% + 0px);
  position: absolute;
  top: -2px;
  left: -2px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 32px;
}
:host .slh-nav-headerbar .slh-nav-link:hover {
  color: var(--slh-color-neutral-shade-10, #F6F7FA);
  text-decoration: none;
}
:host .slh-nav-headerbar .slh-nav-link.primary {
  background-color: var(--slh-color-primary-shade-40, #DAECFF);
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
:host .slh-nav-headerbar .slh-nav-link.primary:hover {
  background-color: var(--slh-color-primary-shade-60, #89B7E5);
  color: var(--slh-color-neutral, #39455D);
}
:host .slh-nav-headerbar .slh-nav-link.primary:focus {
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
}
:host .slh-nav-headerbar .slh-nav-link.primary:focus-visible::after {
  content: "";
  display: block;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  position: absolute;
  top: -4px;
  left: -4px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 32px;
}
:host .slh-nav-headerbar .organization-collapse {
  padding-left: 56px;
  color: var(--slh-color-outline, #4C49D4);
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  padding-bottom: 12px;
  padding-top: 12px;
}
:host .slh-nav-headerbar .organization-collapse:hover {
  text-decoration: underline;
  cursor: pointer;
}
:host .slh-nav-headerbar slh-nav-list:focus {
  position: relative;
  outline: none;
}
:host .slh-nav-headerbar slh-nav-list:focus:after {
  top: -2px;
  left: -2px;
  content: "";
  display: block;
  width: calc(100% + 0px);
  height: calc(100% + 0px);
  position: absolute;
  top: "0px";
  left: "0px";
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 32px;
}
:host .slh-nav-headerbar slh-nav-item.hide {
  display: none;
}
:host .slh-nav-headerbar slh-nav-item .organization-content {
  display: flex;
  width: 100%;
}
:host .slh-nav-headerbar slh-nav-item .organization-content slh-icon {
  margin-left: auto;
  padding-left: 4px;
  fill: var(--slh-color-neutral-shade-80, #4E5E7E);
}

@media (max-width: 560px) {
  :host .slh-nav-headerbar .cart-items .cart-popup {
    max-width: 100%;
    width: 100%;
  }
}
`;
